import { type Result } from '@carvana/merch-result';
import queryString from 'query-string';
import { axios } from '~/clients';
import { DISCOUNTS } from '~/constants/endpoints';
import { DiscountResponse } from './contracts';

export default function fetchDiscounts(
  stateAbbreviation: string,
  userId: string,
  controller?: AbortController
) {
  const query = queryString.stringify({ stateAbbreviation, userId });

  return axios.get<Result<DiscountResponse>>(`${DISCOUNTS}?${query}`, {
    signal: controller?.signal
  });
}
